import { Routes, Route } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import { SuccessBooking } from "../screens/successBooking/SuccessBooking";
import { OTPVerification } from "../screens/otpVerification/OTPVerification";
import { GetStarted } from "../screens/getStarted/GetStarted";
import { Login } from "../screens/login/Login";
import MatchList from "../screens/matchList/MatchList";
import { CourtBookingScreen } from "../screens/courtBooking/CourtBookingScreen";
import { useEffect } from "react";

const ExternalRedirect = ({ url }: { url: string }) => {
  useEffect(() => {
    window.location.replace(url); // replace instead of href to avoid back button looping
  }, [url]);

  return null;
};
const RootRouter = () => {
  return (
    <Routes>
      {/* Redirect `/` to external site */}
      <Route
        path="/"
        element={<ExternalRedirect url="https://ultrapadelclub.com/book" />}
      />

      <Route
        path="/get-started"
        element={
          <PublicRoute>
            <GetStarted />
          </PublicRoute>
        }
      />

      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/otp-verify"
        element={
          <PublicRoute>
            <OTPVerification />
          </PublicRoute>
        }
      />

      <Route
        path="/match-list"
        element={
          <PrivateRoute>
            <MatchList />
          </PrivateRoute>
        }
      />

      <Route
        path="/book-court2"
        element={
          <PrivateRoute>
            <CourtBookingScreen />
          </PrivateRoute>
        }
      />

      <Route
        path="/success"
        element={
          <PrivateRoute>
            <SuccessBooking />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default RootRouter;
